import { useEffect, useState } from 'react';
import styled from 'styled-components';
import IStaffRepository from '../../../../2_domain/staff/iStaffRepository';
import { Staff } from '../../../../2_domain/staff/staff';
import Get from '../../../../lib/di/get';
import promiseResolver from '../../../../lib/util/promiseResolver';
import LXSpinner from '../../spinner/lx_spinner';
import { LXLabelSelector } from './lxSelector';

interface LXStaffSelectorProps {
  staffKind: StaffKind | 'All';
  originStaffId?: Id;
  onSelect: (Staff?: Staff) => void;
  width?: number;
  label?: string;
}

interface ContainerProps {
  width?: number;
}

const Container = styled.div<ContainerProps>`
  width: ${(props) => `${props.width}px` ?? `318px`};
  height: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LXStaffSelector = (props: LXStaffSelectorProps) => {
  const staffRepo = Get.find<IStaffRepository>('IStaffRepository');
  const [staff, setStaff] = useState<Staff>();
  const [staffs, setStaffs] = useState<Staff[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    promiseResolver({
      promise: staffRepo.getStaffs(props.staffKind, '', {
        pageNumber: 0,
        pageSize: 99999,
        isAscending: true,
      }),
      successCallback: (ret) => setStaffs(ret.list),
      isLoadingCallback: setIsLoading,
    });
  }, [props.staffKind, staffRepo]);

  useEffect(() => {
    const filtered = staffs.filter((s) => s.id === props.originStaffId);
    if (filtered.length !== 0) {
      setStaff(filtered[0]);
    } else {
      setStaff(undefined);
    }
  }, [staffs, props.originStaffId]);

  useEffect(() => {
    props.onSelect(staff);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staff]);

  if (isLoading) {
    return (
      <Container width={props.width}>
        <LXSpinner></LXSpinner>
      </Container>
    );
  }

  return (
    <LXLabelSelector<Staff>
      value={staff}
      label={props.label ?? ''}
      values={staffs}
      labels={staffs.map((s) => s.name)}
      onSelect={setStaff}
      dropdownItemWidth={props.width ?? 318}
      dropdownHeaderWidth={props.width ?? 318}
    ></LXLabelSelector>
  );
};

export default LXStaffSelector;
